<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="true"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <!-- eslint-disable-next-line max-len -->
      <v-text-field
        v-model="formattedValue"
        :label="label"
        :rules="rules"
        class="date-picker"
        outlined
        required
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      locale="cs-CZ"
      :min="todayDate"
      @change="change"
      no-title
      scrollable
    >
      <v-spacer></v-spacer>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  props: ['rules', 'label', 'value'],
  data() {
    return {
      menu: false,
      date: this.value,
    };
  },
  computed: {
    formattedValue() {
      return moment(this.date)
        .locale('cs')
        .format('dddd, D. M.');
    },
    todayDate() {
      return moment()
        .locale('cs')
        .format('YYYY-MM-DD');
    },
  },
  methods: {
    change() {
      this.$emit('change', this.date);
      this.$refs.menu.save(this.date);
    },
  },
};
</script>

<style lang="scss">
.date-picker {
  cursor: pointer;
  input:not([disabled]) {
    cursor: pointer;
  }
}
</style>
